import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Snackbar, Alert } from '@mui/material';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { SiteUsersSettingsList } from '@/views/SettingsView/SiteUsersSettings/SiteUsersSettingsList';
import { User } from '@/declarations/models/User';
import { useStore } from '@/components/store/Store';
import { useApi } from '@/hooks/useApi';
import { Api } from '@/services/Api';
import SettingsViewLayout from '../../../components/SettingsViewLayout';
import Container from '../../../components/Container';
import Loader from '../../../components/Loader';

export const SiteUsersSettings: FC = () => {
  const { t: tComponents } = useTranslation('components');
  const { t: tCommon } = useTranslation('common');
  const { state } = useStore();
  const { currentUser } = state;
  const selectedSiteId = state.selectedSite?.id ?? 0;

  const [userList, isLoadingUsers, reloadUsers] = useApi<{ users: User[] }, User[]>(() =>
    Api.getUserSiteRoles(selectedSiteId),
  );

  const [snackbar, setSnackbar] = React.useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    reloadUsers();
  }, [reloadUsers, selectedSiteId]);

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SettingsViewLayout
      title={tComponents('MainMenu.settings.users')}
      saveButtonInHeader={false}
      saveButtonInTop={false}>
      <>
        {isLoadingUsers ? (
          <Container fullWidth fullHeight>
            <Loader size={25} />
          </Container>
        ) : (
          <Container fullHeight top fullWidth column left>
            <Container fullHeight top fullWidth>
              <Container fullWidth top left column gap={2}>
                <Button
                  variant='contained'
                  color='secondary'
                  startIcon={<MaterialSymbol name='save' />}
                  onClick={() => {
                    // TODO
                  }}
                  style={{ display: currentUser?.user?.is_super_admin ? 'inline-flex' : 'none' }}>
                  {tCommon('save')}
                </Button>
                <SiteUsersSettingsList
                  users={userList ?? []}
                  onToggleSuccess={(message: string) => setSnackbar({ open: true, message, severity: 'success' })}
                  onToggleError={(message: string) => setSnackbar({ open: true, message, severity: 'error' })}
                />
              </Container>
            </Container>
          </Container>
        )}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </>
    </SettingsViewLayout>
  );
};

export default SiteUsersSettings;
